import { useState, useEffect } from 'react';
import axios from 'axios';

/**
 * Custom hook to manage fetching products with pagination and searching.
 *
 * @param {string|number} clientId - Optional wholesaler client ID context.
 * @param {string} channel - Order channel: 'retail' (público) or 'wholesale' (mayorista).
 */
export const useProducts = (clientId, channel) => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [count, setCount] = useState(0);
    const [page, setPage] = useState(0); // 0-indexed for frontend compatibility

    // Filters
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const fetchProducts = async () => {
            setLoading(true);
            try {
                const clientParam = clientId ? `&client_id=${clientId}` : '';
                const channelParam = channel ? `&channel=${channel}` : '';
                const searchParam = searchTerm ? `&search=${encodeURIComponent(searchTerm)}` : '';
                const pageParam = `&page=${page + 1}`;

                const prodRes = await axios.get(`/api/products/?is_active=true${clientParam}${channelParam}${searchParam}${pageParam}`);

                if (prodRes.data && prodRes.data.results) {
                    setProducts(prodRes.data.results);
                    setCount(prodRes.data.count);
                } else {
                    setProducts(prodRes.data || []);
                    setCount(prodRes.data ? prodRes.data.length : 0);
                }
                setError('');
            } catch (err) {
                console.error(err);
                setError('Error al cargar productos');
            } finally {
                setLoading(false);
            }
        };

        const delayDebounce = setTimeout(fetchProducts, 300);
        return () => clearTimeout(delayDebounce);
    }, [clientId, channel, page, searchTerm]);

    return {
        products,
        loading,
        error,
        count,
        page,
        setPage,
        searchTerm,
        setSearchTerm: (term) => {
            setSearchTerm(term);
            setPage(0); // Reset to page 1 on search change
        }
    };
};
